/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AgentChatUpdateRequest {
    getFixupPrototypeFunction() { return AgentChatUpdateRequest.fixupPrototype; }

    static newInstance(model: Partial<AgentChatUpdateRequest>): AgentChatUpdateRequest {
        let obj = Object.assign(new AgentChatUpdateRequest(), model);
        AgentChatUpdateRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AgentChatUpdateRequest>): AgentChatUpdateRequest {
        if (!model) return null;
        return AgentChatUpdateRequest.newInstance(<AgentChatUpdateRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AgentChatUpdateRequest) {
        if (!obj) return;

        models.AgentChatUpdateRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AgentChatUpdateRequest): boolean {
        Object.setPrototypeOf(obj, AgentChatUpdateRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Name of the chat
     */
    name: string;

    /**
     * Share the chat with, or unshare it from, the users in user_ids
     */
    share_action: models.AgentChatShareAction;

    /**
     * IDs of the users to share the chat with or unshare it from; required when share_action is set
     */
    user_ids: Array<string>;

}
